import { useEffect, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";
import ProductBasicInfo from "../../../../Components/product/store/productform";
import ProductImages from "../../../../Components/product/store/ProductImages";
import ProductNutrition from "../../../../Components/product/store/ProductNutrition";
import ProductOptions from "../../../../Components/product/store/ProductOptions";
import ProductPrices from "../../../../Components/product/store/productPrices";
import AddsOne from "../../../../Components/stores/storesStore/addsone";
import HeaderBar from "../../../../Components/UI/headerbar";
import { storeProduct } from "../../../../MyApi/product";
import { getCategories } from "../../../../MyApi/product/categories";
import { getStores } from "../../../../MyApi/stores";
import { PRODUCT_SECTION_CONFIG } from "./productconfig";
import { pharmacySchema, restaurantSchema, storeSchema } from "./schema";
import Button from "../../../../Components/UI/buttonGlobal";
import ProductAvailability from "../../../../Components/product/store/productAvability";

const ProductStorePage = () => {
  const [images, setImages] = useState([{ image_path: "", is_primary: 1 }]);
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const storeIdParams = searchParams.get("store_id");
  const storeNameParams =searchParams.get("store_name")
  const storeTypeParams =searchParams.get("store_type")
  const [section_type, setSectionType] = useState("regular_store");
  const [section_id, setSectionId] = useState(null);
  const config = PRODUCT_SECTION_CONFIG[section_type];
  const [addsOnsPayload, setAddsOnsPayload] = useState([]);
    const [groupsState, setGroupsState] = useState({});
  const [selectedAddOnsGroup, setSelectedAddOnsGroup] = useState([]);
 //vendor store
 const is_vendor =JSON.parse(localStorage.getItem("is_vendor")) 
 const userVendor =JSON.parse(localStorage.getItem("user"))
 const storeVendor =userVendor.store
  const [productData, setProductData] = useState({
    barcode: "",
    name: "",
    description: "",
    status: "active",
    note: "",
    is_vegetarian: 1,
    is_reviewed: 1,
    is_featured: 1,
    is_active: 1,
    store_id: "",
    category_id: "",
    max_cart_quantity: 0,
    weight: 0,
    preparation_time: "",
    preparation_time_unit: "",
  });
  

  const [pharmacyInfo, setPharmacyInfo] = useState([
    { generic_name: "", common_use: "", prescription_required: 1 },
  ]);
  const [prices, setPrices] = useState({
    price: 0,
    purchase_price: null,
    sale_price: null,
    currency_factor: "",
  });
console.log('prices', prices.currency_factor)
  useEffect(() => {
    if (storeIdParams) {
      setProductData((prev) => ({
        ...prev,
        store_id: Number(storeIdParams),
        store_name:storeNameParams
      }));
    }
  }, [storeIdParams]);

  // store vendor
 useEffect(()=>{
  if(is_vendor){
      setProductData((prev) => ({
        ...prev,
        store_id: storeVendor.id,
        store_name:storeVendor.name
      }));
      setSectionType(storeVendor.section.type)
  }
 },[])
 useEffect(() => {
   if(storeIdParams){
    setSectionType(storeTypeParams)
   }
 },[] )
  

  const [productNutrition, setProductNutrition] = useState({});

  const [productOptions, setProductOptions] = useState([
    {
      option_id: "",
      min_select: 1,
      max_select: 1,
      is_required: 1,
      sort_order: 1,
      values: [
        {
          name: "",
          price: "",
          stock: "",
          is_in_stock: 1,
        },
      ],
    },
  ]);
  const [availability, setAvailability] = useState([]); 
  // {
  //   stock_quantity: 0,
  //   is_in_stock: 1,
  //   available_start_date: "",
  //   available_end_date: "",
  //   mode:"",
  //   max_quantity:"",
  //   reset_frequency:"" ,
  //   reset_day:"" 
  // }

  const [selectedAddsOns, setSelectedAddsOns] = useState([]);
  const [errors, setErrors] = useState({});

  const [add_ons, setAddsOns] = useState([]);

  const { data ,isLoading:isCategoriesLoading } = useQuery(
    ["getCategories", productData.store_id, section_id],
    () => getCategories(productData.store_id, section_id,"")
  );
  const { data: storesData } = useQuery("getStores", () => getStores());
  const stores = storesData?.data.Stores || [];
  const categories = data?.data.categories || [];

  let steps = [
    { id: 1, key: "product", title: "تفاصيل المنتج", icon: 1 },
  { id: 2, key: "availability", title: "إدارة المخزون وتوفر المنتج", icon: 1 },
    { id: 3, key: "images", title: "الصور", icon: 2 },
    { id: 4, key: "prices", title: "الأسعار", icon: 3 },
    { id: 5, key: "nutrition", title: "القيم الغذائية", icon: 4 },
    { id: 6, key: "options", title: "الخيارات", icon: 5 },
  ];
  console.log("section_type", section_type);
  if (section_type === "restaurant") {
    steps = [
      { id: 1, key: "product", title: "تفاصيل المنتج", icon: 1 },
  { id: 2, key: "availability", title: "إدارة المخزون وتوفر المنتج", icon: 1 },
      { id: 3, key: "images", title: "الصور", icon: 2 },
      { id: 4, key: "prices", title: "الأسعار", icon: 3 },
      { id: 5, key: "nutrition", title: "القيم الغذائية", icon: 4 },
      { id: 6, key: "addon", title: "الإضافات المطلوبة", icon: 5 },
      { id: 7, key: "options", title: "الخيارات", icon: 6 },
    ];
  }
  if (section_type === "pharmacy") {
    steps = [
      { id: 1, key: "product", title: "تفاصيل المنتج", icon: 1 },
     { id: 2, key: "availability", title: "إدارة المخزون وتوفر المنتج", icon: 1 },
      { id: 3, key: "images", title: "الصور", icon: 2 },
      { id: 4, key: "prices", title: "الأسعار", icon: 3 },

      { id: 5, key: "addon", title: "الإضافات", icon: 5 },
      { id: 6, key: "options", title: "تأكيد", icon: 6 },
    ];
  }
const returnPath = location.state?.from || `${process.env.PUBLIC_URL}/products`;
const returnState = location.state?.tab ? { tab: location.state.tab } : {};

console.log('location.state?.from', location)
  const [activeTab, setActiveTab] = useState("product");
  const currentStep = steps.findIndex((s) => s.key === activeTab) + 1;
  const progress = (currentStep / steps.length) * 100;
 const navigate =useNavigate()

 const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationKey: ["postProduct"],
    mutationFn: (postData) => storeProduct(postData),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      queryClient.invalidateQueries(["getProducts"]);
      navigate(returnPath, { state: returnState, replace: true });
    },
    onError: (error) => {
      toast.error(`${error.response.data.message}`);
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();

    // التعامل مع productData
    Object.keys(productData).forEach((key) => {
      if (section_type === "pharmacy" && key === "is_vegetarian") {
        return;
      }
      formData.append(`product[${key}]`, productData[key]);
    });

    // التعامل مع prices
    Object.keys(prices).forEach((key) => {
      if(prices[key] !==null ){
  formData.append(`prices[${key}]`, prices[key]);
      }
    
    });
    if (section_type === "pharmacy") {
      pharmacyInfo.forEach((key, index) => {
        formData.append(
          `pharmacyInfo[${index}][generic_name]`,
          key.generic_name
        );
        formData.append(`pharmacyInfo[${index}][common_use]`, key.common_use);
        formData.append(
          `pharmacyInfo[${index}][prescription_required]`,
          key.prescription_required
        );
      });
    }

    if (productNutrition) {
      Object.keys(productNutrition).forEach((key) => {
        formData.append(`productNutrition[${key}]`, productNutrition[key]);
      });
    }

    // التعامل مع availability
  availability.forEach((item, index) => {
  Object.keys(item).forEach((key) => {
    if (
      item.is_in_stock === 1 &&
      (key === "available_start_date" )
    ) {
      return;
    }

    formData.append(`availability[${index}][${key}]`, item[key]);
  });
});

    images.forEach((img, index) => {
      if (img.file && img.file instanceof File) {
        formData.append(`images[${index}][image_path]`, img.file);
      } else {
        formData.append(`images[${index}][image_path]`, img.image_path);
      }
      formData.append(`images[${index}][is_primary]`, img.is_primary);
    });

     if( addsOnsPayload?.add_on_groups){
      addsOnsPayload?.add_on_groups?.forEach((group, groupIndex) => {
      Object.keys(group).forEach((key) => {
        if (
          group[key] === null ||
          group[key] === "" ||
          group[key] === undefined
        ) {
          return;
        }

        // لو مش add_ons
        if (key !== "add_ons") {
          formData.append(`add_on_groups[${groupIndex}][${key}]`, group[key]);
        }
      });

      // add_ons array
      group.add_ons.forEach((addon, addonIndex) => {
        Object.keys(addon).forEach((addonKey) => {
          if (
            addon[addonKey] === null ||
            addon[addonKey] === "" ||
            addon[addonKey] === undefined
          ) {
            return;
          }

          formData.append(
            `add_on_groups[${groupIndex}][add_ons][${addonIndex}][${addonKey}]`,
            addon[addonKey],
          );
        });
      });
    });
     }


   
      productOptions.forEach((option, index) => {
         if (!option.option_id) return;
        Object.keys(option).forEach((key) => {
          if (key === "values") {
            // values array داخل option
            option.values.forEach((value, vIndex) => {
              Object.keys(value).forEach((valKey) => {
                formData.append(
                  `productOptions[${index}][values][${vIndex}][${valKey}]`,
                  value[valKey]
                );
              });
            });
          } else {
            formData.append(`productOptions[${index}][${key}]`, option[key]);
          }
        });
      });


    mutation.mutate(formData);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "product":
        return (
          <ProductBasicInfo
            errors={errors}
            stores={stores}
            productData={productData}
            setProductData={setProductData}
            categories={categories}
            availability={availability}
            setAvailability={setAvailability}
            setSectionType={setSectionType}
            section_type={section_type}
            pharmacyInfo={pharmacyInfo}
            setErrors={setErrors}
            setPharmacyInfo={setPharmacyInfo}
            setPrices={setPrices}
            setSectionId={setSectionId}
            isCategoriesLoading={isCategoriesLoading}
            is_vendor={is_vendor}
          />
        );
        case "availability":
        return (
          <div className="row">
            <ProductAvailability mode="add"   availability={availability}  setAvailability={setAvailability} storeId={productData.store_id}/>
            </div>
        );

      case "images":
        return (
          <ProductImages
            images={images}
            setImages={setImages}
            setErrors={setErrors}
            errors={errors}
            
          />
        );

        
      case "prices":
        return (
          <ProductPrices
            prices={prices}
            setPrices={setPrices}
            errors={errors}
          />
        );
      case "nutrition":
        return (
          config?.show?.nutrition && (
            <ProductNutrition
              productNutrition={productNutrition}
              setProductNutrition={setProductNutrition}
            />
          )
        );
      case "addon":
        return (
          config.show.addons && (
            <AddsOne  product={prices}   setSelectedAddOnsGroup={setSelectedAddOnsGroup} selectedAddOnsGroup={selectedAddOnsGroup} groupsState={groupsState} setGroupsState={setGroupsState} setAddsOnsPayload={setAddsOnsPayload} setAddsOns={setAddsOns} store_id={productData.store_id} selectedAddsOns={selectedAddsOns} setSelectedAddsOns={setSelectedAddsOns} />
          )
        );
      case "options":
        return (
          config.show.options && (
            <ProductOptions
              productOptions={productOptions}
              setProductOptions={setProductOptions}
            />
          )
        );
      default:
        return null;
    }
  };

  const goToNextStep = () => {
    const currentIndex = steps.findIndex((s) => s.key === activeTab);
    console.log("currentIndex", currentIndex);
    setActiveTab(steps[currentIndex + 1].key);
  };
  const getStepData = (stepKey) => {
    switch (stepKey) {
      case "product":
        return {
          ...productData,
        };
        case "availability":
         return availability
      case "images":
        return images;
      case "prices":
        return prices;
      case "nutrition":
        return productNutrition;
      case "options":
        return {
          productOptions: productOptions,
          add_ons: add_ons,
        };
      default:
        return {};
    }
  };

  return (
    <>
      <HeaderBar
        title={"إضافة منتج جديد"}
        content={"أضف منتج جديد لمتجرك"}
        isBack={true}
      />
      <form onSubmit={handleSubmit} className="product-form add">
        <div className="container">
          <div className="card rounded-4">
            <div className="card-body">
              <div className="row mb-2 justify-content-center align-items-center">
                <div
                  className="position-relative mt-3 "
                  style={{ height: "40px" }}
                >
                  {/* Progress bar */}

                  {/* Steps circles */}
                  <div className="d-flex justify-content-between align-items-center position-absolute top-0 start-0 w-100 translate-middle-y">
                    {steps.map((s) => (
                      <div
                        key={s.id}
                        className="d-flex align-items-center justify-content-center rounded-circle"
                        style={{
                          width: "40px",
                          height: "40px",
                          zIndex: "10",
                          backgroundColor:
                            currentStep >= s.id ? "#FFCC03" : "#E6E6E6",
                          color: "#fff",
                          fontWeight: "bold",
                        }}
                      >
                        {s.id}
                      </div>
                    ))}
                    <div
                      className="progress position-absolute  start-0 w-100 "
                      style={{ height: "12px", top: "40%" }}
                    >
                      <div
                        className="progress-bar bg-primary"
                        role="progressbar"
                        style={{ width: `${progress}%` }}
                      />
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-between  mb-3">
                  {steps.map((s) => (
                    <small
                      key={s.id}
                      className={`${
                        currentStep >= s.id
                          ? "text-success fw-bold"
                          : "text-muted"
                      } font14`}
                    >
                      {s.title}
                    </small>
                  ))}
                </div>
              </div>

              {/* 🧩 محتوى التبويب */}
              {renderTabContent()}

              {/* أزرار التنقل */}
              <div className="mt-4 d-flex justify-content-between">
                <div>
                  {activeTab !== "product" && (
                    <button
                      type="button"
                      className="btn btn-white me-2"
                      onClick={() => {
                        const currentIndex = steps.findIndex(
                          (s) => s.key === activeTab
                        );
                        setActiveTab(steps[currentIndex - 1].key);
                      }}
                    >
                      السابق
                    </button>
                  )}
                  {activeTab === "options" ? null : (
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => {
                        const schema =
                          section_type === "regular_store"
                            ? storeSchema[activeTab]
                            : section_type === "restaurant"
                            ? restaurantSchema[activeTab]
                            : section_type === "pharmacy"
                            ? pharmacySchema[activeTab]
                            : "";
                        console.log(
                          "activeTab",
                          schema,
                          section_type === "restaurant" 
                        );
                        if (!schema) return;

                        // نجمع الداتا الخاصة بالـ step
                        const payload = getStepData(activeTab); // function ترجع الداتا الخاصة بالـ step
                    
                        const result = schema.safeParse(payload);
                   
                        if (!result.success) {
                          setErrors(result.error.flatten().fieldErrors); // عرض الأخطاء
                          return; // ممنوع الانتقال
                        }

                        setErrors({});
                        goToNextStep();
                      }}
                    >
                      التالي
                    </button>
                  )}
                </div>

                <div>
                  {activeTab !== "options" ? null : (
                    <Button
                      isLoading={mutation.isLoading}
                      type={"submit"}
                      className={"btn-primary"}
                      label={" تأكيد إضافة المنتج"}
                      disabled={mutation.isLoading}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default ProductStorePage;
